/**
 * @file Saga updating the agency's own company (`PUT company/:id`, answering `{data: <company>}`) from the settings page or coach.
 * A refused update runs ErrorHandlerSequence and PAGE_CONTACT_COMPANY_UPDATE_FAILURE.
 */
import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import Translator from "../../Translation/Translator";
import CompanyFactory from "../../Entity/Factories/CompanyFactory";
import { ActionInterface } from "../../Interface/ActionInterface";
import { CompanyInterface } from "../../Entity/Entities/Company/CompanyInterface";

export default function* agencyUpdate(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.PAGE_SETTINGS_AGENCY_PROFILE_UPDATE_CLEAR
    });

    yield put({
      type: Constants.PAGE_SETTINGS_AGENCY_PROFILE_UPDATE_REQUEST
    });

    const res = yield call(Http.put, `company/${action.payload?.id}`, action.payload?.agency);
    const agency: CompanyInterface = CompanyFactory.create(res.data.data);

    yield put({
      type: Constants.PAGE_CONTACT_COMPANY_UPDATE_SUCCESS,
      payload: {
        company: agency
      }
    });

    yield put({
      type: Constants.SNACKBAR_ADD_MESSAGE,
      payload: {
        message: Translator.trans("snackbar-message-agency-settings-updated-successfully"),
        type: "success"
      }
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, agency);
    }
  } catch (err) {

    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.PAGE_CONTACT_COMPANY_UPDATE_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchAgencyUpdate() {
  yield takeEvery(Constants.PAGE_SETTINGS_AGENCY_PROFILE_UPDATE_START, agencyUpdate);
}
